import { render, staticRenderFns } from "./CommentEventLogItem.vue?vue&type=template&id=43372f30&scoped=true&"
import script from "./CommentEventLogItem.vue?vue&type=script&lang=js&"
export * from "./CommentEventLogItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentEventLogItem.vue?vue&type=style&index=0&id=43372f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43372f30",
  null
  
)

export default component.exports